import { SuggestionWithIdAndValue } from '../ComboboxTypes';

export type SelectSuggestionOption = {
    setNavSuggestion: (suggestion: SuggestionWithIdAndValue | null) => void;
    navSuggestion: SuggestionWithIdAndValue | null;
    currentSuggestions: SuggestionWithIdAndValue[];
};

export const findAndSetSelctedSuggestion = (
    e: KeyboardEvent,
    { setNavSuggestion, navSuggestion, currentSuggestions }: SelectSuggestionOption,
): void => {
    e.preventDefault();

    const currentIndex = currentSuggestions.findIndex((suggestion) => suggestion.id === navSuggestion?.id);

    const nextIndex = currentIndex + 1;
    const prevIndex = currentIndex - 1;

    if (e.key === 'ArrowDown') {
        setNavSuggestion(nextIndex > currentSuggestions.length ? null : currentSuggestions[nextIndex]);
        return;
    }

    if (e.key === 'ArrowUp') {
        if (prevIndex === -2) {
            setNavSuggestion(currentSuggestions[currentSuggestions.length - 1]);
            return;
        }

        setNavSuggestion(prevIndex < 0 ? null : currentSuggestions[prevIndex]);
        return;
    }

    if (e.key === 'PageUp') {
        setNavSuggestion(currentIndex - 10 < 0 ? currentSuggestions[0] : currentSuggestions[currentIndex - 10]);
        return;
    }

    if (e.key === 'PageDown') {
        setNavSuggestion(
            currentIndex + 10 > currentSuggestions.length
                ? currentSuggestions[currentSuggestions.length - 1]
                : currentSuggestions[currentIndex + 10],
        );
        return;
    }

    if (e.key === 'Home') {
        setNavSuggestion(currentSuggestions[0]);
        return;
    }

    if (e.key === 'End') {
        setNavSuggestion(currentSuggestions[currentSuggestions.length - 1]);
    }
};
